import { createSelector } from 'reselect';

import { RootState } from 'app/store';

import getSortedUniqueCurrencies from 'utils/getSortedUniqueCurrencies';

import { ErrorResponse } from 'types/api';
import { FormattedOption } from 'types/dictionaries';

import { Dictionaries, RequestStatus } from 'constants/enums';

export const selectAllDictionaries = () => (state: RootState) =>
  state.dictionaries.data;

export const selectDictionary =
  (dict: string) =>
  (state: RootState): FormattedOption[] =>
    state.dictionaries.data[dict] || [];

export const selectDictionariesStatus = (state: RootState): string =>
  state.dictionaries.status;

export const selectIsDictionariesLoading = (state: RootState): boolean =>
  state.dictionaries.status === RequestStatus.Loading;

export const selectDictionariesError = (
  state: RootState
): ErrorResponse | null => state.dictionaries.error;

export const selectIndustries = createSelector(
  (state: RootState) => state.dictionaries.data,
  (data) => data[Dictionaries.Industry] || []
);

export const selectCountryWithCurrencyDictionary = (state: RootState) =>
  state.dictionaries.countryWithCurrency;

export const selectUniqueCurrencyCodes = createSelector(
  selectCountryWithCurrencyDictionary,
  (countries) =>
    getSortedUniqueCurrencies(countries.map(({ currency }) => currency))
);

export const selectCurrencyByCountryCode =
  (countryCode?: string) =>
  (state: RootState): string | null =>
    selectCountryWithCurrencyDictionary(state).find(
      ({ countryCode: code }) => code === countryCode
    )?.currency ?? null;
